import React from 'react';
import Plasma from '../assets/img/XHMJINPB0JW.png';
import Orthopedic from '../assets/img/shutterstock_62766982.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';

function BoneMarrow() {
    return (
        <>
            <Header1 />
                <section className='blog-wrapper news-wrapper section-padding'>
                    <div className='container'>
                        <div className='row'>
                            <div className="col-md-12">
                                <div className="news-content">
                                    <div className="section-heading marginbot20">
                                        <p><strong>Bonemarrow </strong>  Derived Stemcell Kits </p><h5></h5><p className='mb-3'></p>
                                    </div>
                                    <p className='mb-3'>
                                        Stem cell plasticity refers to the ability of adult stem cells to acquire mature phenotypes that are different from their tissue of origin. Adult bone marrow cells (BMCs) include two populations of bone marrow stem cells (BMCs): hematopoietic stem cells (HSCs), which give rise to all mature lineages of blood, and mesenchymal stem cells (MSCs), which can differentiate into bone, cartilage, and fat.
                                    </p><p className='mb-3'>&nbsp;</p>
                                    <p className='mb-3'>&nbsp;</p><p className='mb-3'>&nbsp;</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            <Footer1 />
        </>
    );
}

export default BoneMarrow;
